import { useQuery } from '@tanstack/react-query'
import { api } from '../../lib/api'
import { qk } from '../../lib/query'
import { Icon } from '../icons'

/**
 * The listing a conversation is about, pinned above the thread.
 *
 * A marketplace question always concerns one product, and until now the agent had to infer
 * which from the question text alone — "Qtos rolos preciso comprar?" says nothing about what
 * is being asked about.
 *
 * The link opens the real listing in a new tab. That is for the AGENT: an outbound link inside
 * a customer message is a compliance problem, and the gate blocks it there. Here it is just
 * the fastest route to the source of truth when the answer is not in the panel.
 */
export function ProductBanner({ conversationId }: { conversationId: string }) {
  const { data } = useQuery({
    queryKey: qk.conversationProduct(conversationId),
    queryFn: () => api.conversationProduct(conversationId),
  })
  if (!data) return null

  const coverage = Object.entries(data.attributes ?? {}).find(([k]) =>
    /cobertura|área|area|medida|tamanho/i.test(k),
  )

  return (
    <div className="prod-banner">
      {data.imageUrl ? (
        <img className="pb-img" src={data.imageUrl} alt={data.title} loading="lazy" referrerPolicy="no-referrer" />
      ) : (
        <span className="pb-img ph">
          <Icon name="box" size={16} />
        </span>
      )}
      <div className="pb-body">
        <div className="pb-title" title={data.title}>
          {data.title}
        </div>
        <div className="pb-meta">
          <span className="pb-sku">{data.sku}</span>
          {data.price ? <span>R$ {data.price.toFixed(2).replace('.', ',')}</span> : null}
          {coverage ? <span>{coverage[1]}</span> : null}
        </div>
      </div>
      {data.permalink && (
        <a className="pb-link" href={data.permalink} target="_blank" rel="noreferrer noopener">
          Ver anúncio
          <Icon name="ext" size={12} />
        </a>
      )}
    </div>
  )
}
